<template>
  <Dialog title="Modifier les priorités des cultures" :show='show' okText='Enregister' @cancel="$emit('cancel')" @validate="onValidate" class="large">
     <span class="instruction">Sélectionnez un scénario puis priorisez les cultures en les triant à l'aide de glisser/déposer dans la partie de droite</span>
     <v-field-select
      class="no-margin"
      label="scénario"
      v-model="scenario"
      :options="scenarios"
      @input="onSelectScenario"
      placeholder="Scénario"
      track-by="nom"
      labelField="nom"
      valueField=""
      :searchable="false"
      :showLabels="false"
      :allow-empty="false"
      name="choiceScenario"
     />
    <div class="groups ct-flex-row">
      <div class="group item-flex-full">
        <div class="draggable-title">Culture(s) non triée(s)</div>
        <Container class="overflow-scroll height-full draggable-container" group-name="1" :get-child-payload="getChildPayload1" @drop="r => onDrop(parcellesNonTriees, r)">
          <Draggable class="draggable-wrapper" v-for="parcelle in parcellesNonTriees" :key="parcelle.id">
            <div class="draggable-item">
              <div>{{parcelle.culture}}<span class="align-icon-right btn-icon right-arrow-b btn-icon-arrow-size" @click="onClickToAdd(parcelle, parcellesNonTriees, parcellesTriees)"></span></div>
              <div class="sous-information">{{parcelle.sol}} ({{ parcelle.surface }} ha)</div>
            </div>
          </Draggable>
        </Container>
      </div>
      <div class="group item-flex-full">
        <div class="draggable-title">Culture(s) triée(s) par priorité</div>
        <Container class="overflow-scroll height-full draggable-container" group-name="1" :get-child-payload="getChildPayload2" @drop="r => onDrop(parcellesTriees, r)">
          <Draggable class="draggable-wrapper" v-for="parcelle in parcellesTriees" :key="parcelle.id">
            <div class="draggable-item">
              <div>{{parcelle.culture}}<span class="align-icon-left btn-icon left-arrow-b btn-icon-arrow-size" style="margin-left: -8px;" @click="onClickToAdd(parcelle, parcellesTriees, parcellesNonTriees)"></span></div>
              <div class="sous-information">{{parcelle.sol}} ({{ parcelle.surface }} ha)</div>
            </div>
          </Draggable>
        </Container>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog'
import { Container, Draggable } from 'vue-smooth-dnd'

export default {
  name: 'Priorite',

  components: {
    Dialog, Container, Draggable
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    scenarios: {
      type: Array
    },
    sols: {
      type: Array
    },
    cultures: {
      type: Array
    },
    parcelles: {
      type: Array
    }
  },

  data () {
    return {
      scenario: null,
      allParcelles: [],
      parcellesNonTriees: [],
      parcellesTriees: [],
      allData: {}
    }
  },

  watch: {
    show: function (newValue) {
      if (newValue === true) {
        this.initData()
        this.onSelectScenario(this.$store.state.simulation.currentSimulation.scenarios[0])
      }
    }
  },

  methods: {
    initData () {
      // Phase 1 -> on récupère toute les parcelles, on définit un ordre initial et on récupère les noms des sols/cultures
      let parcelles = this.parcelles.map(p => {
        let culture = this.cultures.find(c => c.id_culture === p.id_culture)

        return ({
          ordre: 0,
          ...p,
          sol: this.sols.find(s => s.id_ref_type_sol === p.id_ref_type_sol).nom,
          culture: culture.nom + (culture.complement ? ' - ' + culture.complement : '')
        })
      })

      // Phase 2 -> répartition des parcelles par scénario et si ordonnées ou pas
      this.allData = parcelles.reduce((acc, p) => {
        acc[p.id_scenario] = acc[p.id_scenario] || { nonTries: [], tries: [] }
        acc[p.id_scenario][p.ordre === 0 ? 'nonTries' : 'tries'].push(p)
        return acc
      }, {})

      // Phase 3 -> tri des données "triés" par leur ordre
      Object.entries(this.allData).forEach(([idScenario, elem]) => {
        elem.tries.sort((a, b) => a.ordre - b.ordre)
      })
    },
    onSelectScenario (scenario) {
      this.scenario = scenario
      this.parcellesNonTriees = (this.allData[scenario.id_scenario] || {}).nonTries
      this.parcellesTriees = (this.allData[scenario.id_scenario] || {}).tries
    },
    getChildPayload1 (index) {
      return this.parcellesNonTriees[index]
    },
    getChildPayload2 (index) {
      return this.parcellesTriees[index]
    },
    onDrop (collection, result) {
      if (result.removedIndex === null && result.addedIndex === null) return
      let itemToAdd = result.payload

      if (result.removedIndex !== null) {
        itemToAdd = collection.splice(result.removedIndex, 1)[0]
      }

      if (result.addedIndex !== null) {
        collection.splice(result.addedIndex, 0, itemToAdd)
      }
    },
    onClickToAdd (parcelle, fromList, destinationList) {
      let indexToRemove = fromList.indexOf(parcelle)
      fromList.splice(indexToRemove, 1)
      destinationList.push(parcelle)
    },
    onValidate () {
      let parcelles = []
      Object.entries(this.allData).forEach(([idScenario, elem]) => {
        elem.nonTries.forEach(p => (p.ordre = 0))
        elem.tries.forEach((p, index) => (p.ordre = index + 1))
        parcelles.push(...elem.nonTries, ...elem.tries)
      })
      this.$emit('validate', parcelles)
    }
  }
}
</script>

<style>

</style>
